import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  medal: '🥇',
  n: 'Bono #1',
  title: 'El Traductor del “No Sé”',
  desc: 'Cuando un paciente responde “No sé”, la mayoría de las sesiones se estanca. Descubre las preguntas exactas que transforman ese bloqueo en una conversación profunda y reveladora.',
  value: '$27 USD',
  img: 'https://cdn.magicpatterns.com/uploads/9SL5dgsEHd3NfhxztxCpRx/BONO_1_PREGUNTAS.png'
}, {
  medal: '🥈',
  n: 'Bono #2',
  title: 'El Botón de Pánico',
  desc: '¿Alguna vez te has quedado pensando qué preguntar mientras el paciente guarda silencio? Con este protocolo tendrás 15 frases de rescate listas para recuperar el control de la sesión.',
  value: '$27 USD',
  img: 'https://cdn.magicpatterns.com/uploads/6Rg7rCYhn6SSScdjk9PbqA/BONO_2_PREGUNTAS.png'
}, {
  medal: '🥉',
  n: 'Bono #3',
  title: 'La Hoja Maestra de la Sesión Perfecta',
  desc: 'Nunca vuelvas a improvisar la estructura de una sesión. Ten siempre frente a ti una guía visual que te indique cómo abrir, profundizar y cerrar cada consulta de forma estratégica.',
  value: '$19 USD',
  img: 'https://cdn.magicpatterns.com/uploads/bdQC214HDSX2yZAUDjXkKP/BONO_3_PREGUNTAS.png'
}, {
  medal: '🎯',
  n: 'Bono #4',
  title: 'El Detector de Pacientes Resistentes',
  desc: 'Aprende a reconocer las señales que indican cuándo un paciente está evitando profundizar y descubre el momento exacto para formular la pregunta que rompe la resistencia.',
  value: '$37 USD',
  img: 'https://cdn.magicpatterns.com/uploads/gAnXqfNL5o228gT35U4HdH/BONO_4_PREGUNTAS.png'
}, {
  medal: '📒',
  n: 'Bono #5',
  title: 'La Bitácora del Terapeuta Experto',
  desc: 'Convierte cada sesión en información valiosa. Registra patrones, insights y avances clave para dar continuidad al proceso terapéutico y llegar mejor preparado a cada consulta.',
  value: '$27 USD',
  img: 'https://cdn.magicpatterns.com/uploads/pe3WR2hDwKstA1tsp6ogNS/BONO_5_PREGUNTAS.png'
}, {
  medal: '🌿',
  n: 'Bono #6',
  title: 'El Ritual de Cierre del Terapeuta',
  desc: 'Después de acompañar emociones intensas todo el día, también necesitas cuidar las tuyas. Aprende un protocolo sencillo para reducir el desgaste emocional y terminar tu jornada en equilibrio.',
  value: '$25 USD',
  img: 'https://cdn.magicpatterns.com/uploads/23cXTMep5CCbaZithiPbfr/BONO_6_PREGUNTAS-2.png'
}];
export function BonusSection() {
  return <section className="bg-gradient-to-b from-[#4a1d6a] to-[#5b2580] px-4 py-14 text-white" data-id="element-26" data-mp="tfnnedvjki0o">
      <div className="mx-auto max-w-md text-center" data-id="element-27" data-mp="176ipn7bjc0va">
        <div className="mx-auto mb-4 inline-flex items-center gap-2 rounded-full bg-pink/20 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-pink" data-id="element-28" data-mp="12dzba850x1pf">
          <GiftIcon className="h-4 w-4" data-id="element-29" data-mp="emtwlwatkfgp" /> 6 Bonos exclusivos GRATIS
        </div>
        <h2 className="font-display text-3xl font-bold leading-tight" data-id="element-30" data-mp="amth08bzhy82">
          Además recibirás GRATIS estos 6 bonos exclusivos.
        </h2>
        <p className="mt-3 text-[15px] text-white/75" data-id="element-31" data-mp="59uvhk60vjg9">
          Porque hay momentos en los que incluso los mejores terapeutas necesitan un recurso de
          apoyo. Y queremos que siempre tengas una respuesta lista.
        </p>

        <div className="mt-8 space-y-4" data-id="element-32" data-mp="3rqqz8f334b9t">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="overflow-hidden rounded-2xl bg-white text-plum shadow-lg" data-id="element-33" data-mp="j9cqih9wvsy2" data-mpi={i}>
              <div className="bg-[#f7eef6] p-4" data-id="element-34" data-mp="e9hw43qxgl89">
                <img src={b.img} alt={b.title} className="mx-auto h-40 w-auto object-contain" loading="lazy" data-id="element-35" data-mp="2u1xdqey02r2k" />
              </div>
              <div className="p-5 text-left" data-id="element-36" data-mp="3f8om0t1t5g44">
                <div className="flex items-center gap-2" data-id="element-37" data-mp="3f9hin171yp8j">
                  <span className="text-xl" data-id="element-38" data-mp="3ah6ibx8eh1fg">{b.medal}</span>
                  <span className="rounded-full bg-plum px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider text-white" data-id="element-39" data-mp="3afln05e9hegj">
                    {b.n}
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-lg font-bold text-plum" data-id="element-40" data-mp="30hfo7wnr4ofw">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-plum/70" data-id="element-41" data-mp="1zafp9g1egyy">{b.desc}</p>
                <div className="mt-3 flex flex-wrap items-center gap-2" data-id="element-42" data-mp="3t8pogcxq0vlp">
                  <span className="text-sm text-plum/50 line-through" data-id="element-43" data-mp="3o7jqo0p7ei5b">
                    Valor: {b.value}
                  </span>
                  <span className="rounded-full bg-emerald-100 px-3 py-1 text-xs font-bold text-emerald-700" data-id="element-44" data-mp="3jbunlndz6j49">
                    🎁 HOY GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}